$(document).on('click', '.listed-category',function () {
  var category_id = $(this).data('category-id')
  $.ajax({
    url: '/categories/' + category_id,
    type: "get",
    data: {
      category_id: category_id
    },
    dataType: "script"
  });
});

$(document).on('click', '.not-have-modifiers-variations', function () {
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  $(this).addClass('d-none');
  add_to_cart(item_id, 1);
  $('.item_' + item_id + '-quantity-handler').removeClass('d-none');
});

$(document).on('click', '.plus-quantity', function () {
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  var max_qty = $(this).data('max-qty');
  increase_quantity(item_id, max_qty);
  update_total(item_id, key);
});

$(document).on('click', '.minus-quantity', function () {
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  decrease_quantity(item_id, $(this));
  update_total(item_id, key);
});

$(document).on('click', '.plus-quantity-from-popup', function () {
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  var old_quantity = get_current_quantity(item_id)
  var updated_quantity = parseInt(old_quantity) + 1
  $('.quantity-box-' + item_id).text(updated_quantity);
  $('.quantity-box-' + key).text(updated_quantity);
  $('.item-pop-quantity-box-' + item_id).val(updated_quantity);
  $('.item-pop-quantity-box-' + key).val(updated_quantity);
  $('.item_' + key + '_increase_decrease').val(true);
  // manage_selected_modifier_quantity(item_id, updated_quantity)
  update_total(item_id, key);
  check_all_conditions_are_satisfied(item_id)
});

$(document).on('click', '.plus-modifier-quantity-from-popup', function () {
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  var modifier_id = $(this).data('modifier-id');
  var old_quantity = get_modifier_current_quantity(item_id, modifier_id)
  var updated_quantity = parseInt(old_quantity) + 1
  $('.modifier-item-' + item_id + '-quantity-box-' + modifier_id).val(updated_quantity);
  update_total(item_id, key);
});

$(document).on('keyup', '.modifier-quantity', function () {
  var maximum_allowed = $(this).data('maximum-allowed')
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  var modifier_id = $(this).data('modifier-id');
  var modifier_set_id = $(this).data('modifier-set-id');
  var old_quantity = get_modifier_current_quantity_with_null(item_id, modifier_id)

  if ((parseInt(old_quantity) <= 0)) {
    var updated_quantity = 0
    $('#item_' + key + '_modifier_' + modifier_id + '_quantity_section').addClass('d-none');
    $('.modifier-item-' + item_id + '-quantity-box-' + modifier_id).val(updated_quantity);
    $('#item_' + item_id + '_modifier_set_' + modifier_set_id + '_modifier_' + modifier_id).prop('checked', false)
    $(".item_" + key + "_modifier_set_" + modifier_set_id + "_div").removeClass("disable-div")
    $(".item_"+ key + "_modifier_" + modifier_id + "_div").addClass("item_" + key + "_modifier_set_" + modifier_set_id + "_div")
    console.log('===========new========' + maximum_allowed)
    if (maximum_allowed != 0 && maximum_allowed == $(".item_" + key + "_modifier_set_" + modifier_set_id + "_modifier:checked").length){
      $(".item_" + key + "_modifier_set_" + modifier_set_id + "_div").addClass("disable-div")
    }
  }
  if ((parseInt(updated_quantity) || 0) == 0) {
    $('.add_item_button_' + item_id).prop('disabled', true);
  }
  $('.item_' + item_id + '_increase_decrease').val(true);
});

$(document).on('click', '.minus-modifier-quantity-from-popup', function () {
  var maximum_allowed = $(this).data('maximum-allowed')
  var minimum_required = $(this).data('minimum-required')
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  var modifier_id = $(this).data('modifier-id');
  var modifier_set_id = $(this).data('modifier-set-id');
  var old_quantity = get_modifier_current_quantity(item_id, modifier_id)
  if ((old_quantity == 1) || (old_quantity == 0)) {
    var updated_quantity = 0
    $('#item_' + key + '_modifier_' + modifier_id + '_quantity_section').addClass('d-none');
    $('.modifier-item-' + item_id + '-quantity-box-' + modifier_id).val(updated_quantity);
    $('#item_' + item_id + '_modifier_set_' + modifier_set_id + '_modifier_' + modifier_id).prop('checked', false)
    $(".item_" + key + "_modifier_set_" + modifier_set_id + "_div").removeClass("disable-div")
    $(".item_"+ key + "_modifier_" + modifier_id + "_div").addClass("item_" + key + "_modifier_set_" + modifier_set_id + "_div")
    
    checked_modifiers = $(".item_" + key + "_modifier_set_" + modifier_set_id + "_modifier:checked").length
    if (maximum_allowed != ''){
      console.log('===========new3========' + maximum_allowed)
      if (maximum_allowed != 0  && maximum_allowed == checked_modifiers){
        $(".item_" + key + "_modifier_set_" + modifier_set_id + "_div").addClass("disable-div")
      }
    }
  } else {
    var updated_quantity = parseInt(old_quantity) - 1
    $('.modifier-item-' + item_id + '-quantity-box-' + modifier_id).val(updated_quantity);
  }
  update_total(item_id, key);
  if (((parseInt(updated_quantity) || 0) == 0 && maximum_allowed != '' && checked_modifiers < minimum_required) || checked_modifiers > maximum_allowed) {
    $('.add_item_button_' + item_id).prop('disabled', true);
  }
  $('.item_' + item_id + '_increase_decrease').val(true);
});

$(document).on('click', '.minus-quantity-from-popup', function () {
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  var old_quantity = get_current_quantity(item_id)
  if (old_quantity == 1) {
    var updated_quantity = 1
    $(this).attr('pointer-events', 'none')
  } else {
    var updated_quantity = parseInt(old_quantity) - 1
    $('.quantity-box-' + item_id).text(updated_quantity);
    $('.item-pop-quantity-box-' + item_id).val(updated_quantity);
    $('.quantity-box-' + key).text(updated_quantity);
    $('.item-pop-quantity-box-' + key).val(updated_quantity);
    update_total(item_id, key);
  }
  if ((parseInt(updated_quantity) || 0) == 0 ) {
    $('.add_item_button_' + item_id).prop('disabled', true);
  }
  $('.item_' + key + '_increase_decrease').val(true);
});

function increase_quantity(item_id, max_qty) {
  var old_quantity = get_current_quantity(item_id)
  var updated_quantity = parseInt(old_quantity) + 1
  if (old_quantity == max_qty) {
    $(this).attr('pointer-events', 'none')
  } else {
    add_to_cart_according_variation(item_id, updated_quantity)
    $('.quantity-box-' + item_id).text(updated_quantity);
    $('.item-pop-quantity-box-').val(updated_quantity);
  }
}

function decrease_quantity(item_id, element) {
  var old_quantity = get_current_quantity(item_id)
  var updated_quantity = parseInt(old_quantity) - 1
  if (old_quantity == 1) {
    element.attr('pointer-events', 'none')
  } else {
    add_to_cart_according_variation(item_id, updated_quantity)
    $('.quantity-box-' + item_id).text(updated_quantity);
    $('.item-pop-quantity-box-').val(updated_quantity);
  }
}

function add_to_cart_according_variation(item_id, updated_quantity){
  if (typeof item_id == 'number'){
    add_to_cart(item_id, updated_quantity, "", true);
  }
  else {
    add_to_cart(item_id, updated_quantity, true, true);
  }
}

function get_item_id(element) {
  var item_id = $(element).data('item-id');
  return [item_id.toString().split("-")[0], item_id];
}

function get_current_quantity(item_id) {
  var current_quantity = $('.item-pop-quantity-box-' + item_id).val();
  return (parseInt(current_quantity) || 0)
}

function get_modifier_current_quantity(item_id, modifier_id) {
  var current_quantity = $('.modifier-item-' + item_id + '-quantity-box-' + modifier_id).val();
  return (parseInt(current_quantity) || 0)
}

function get_modifier_current_quantity_with_null(item_id, modifier_id) {
  var current_quantity = $('.modifier-item-' + item_id + '-quantity-box-' + modifier_id).val();
  return (parseInt(current_quantity))
}

function manage_selected_modifier_quantity(item_id, updated_quantity) {
  var all_modifier_sets = $('.item_' + item_id + '_modifier_sets');
  for (let modifier_set = 0; modifier_set < all_modifier_sets.length; modifier_set++) {
    const element = all_modifier_sets[modifier_set];
    var modifier_set_id = $(element).data('modifier-set-id');
    var added_modifiers = $('input.item_' + item_id +'_modifier_set_' + modifier_set_id + '_modifier:checkbox:checked');
  for (let modifier = 0; modifier < added_modifiers.length; modifier++) {
    modifier_quantity = $('.modifier-item-' + item_id + '-quantity-box-' + $(added_modifiers[modifier]).data('modifier-id')).val()
    $('.modifier-item-' + item_id + '-quantity-box-' + $(added_modifiers[modifier]).data('modifier-id')).val(parseInt(modifier_quantity) * parseInt(updated_quantity))
  }
  }
}

function add_to_cart(item_id, quantity, item_with_modifier, increase_decrease) {
  var modifier_ids = $('.item_' + item_id + '_modifier_ids').val();
  var variation_id = $('.item_' + item_id + '_variation_ids').val();
  var item_timestamp = $('.item_' + item_id + '_timestamp').val();
  if (modifier_ids == undefined) {
    modifier_ids = ''
  }
  if (variation_id == undefined) {
    variation_id = ''
  }
  $.ajax({
    url: '/add_to_cart',
    type: "post",
    data: {
      item_id: item_id,
      "item[item_id]": item_id,
      "item[quantity]": quantity,
      "item[modifiers]": modifier_ids.split(' '),
      "variation_id": variation_id,
      "timestamp": item_timestamp,
      "item_with_modifier": item_with_modifier,
      "increase_decrease": increase_decrease
    },
    dataType: "script"
  });
}

$(document).on('click', '.remove-item-from-cart', function () {
  $.ajax({
    url: '/remove_item_from_cart',
    type: "put",
    data: {
      item_with_timestamp: $(this).data('item-id'),
      page: $(this).data('page')
    },
    dataType: "script"
  });
})

$(document).on('click', '.login_header_button', function (e) {
  e.preventDefault();
  $.ajax({
    url: '/login_from_header',
    type: "get",
    data: {

    },
    dataType: "script"
  });
});

$(document).on('click', '.add_to_order_button', function (e) {
  if ($('#form-item-'+item_id.value).parsley().validate()){
    $('.cart-footer').addClass('disable-div');
  }
});

$(document).on('click', '.change-form', function () {
  if ($(this).attr("id") == 'email_id') {
    $('.phone-section').addClass('d-none');
    $('.email-section').removeClass('d-none');
  } else {
    $('.email-section').addClass('d-none');
    $('.phone-section').removeClass('d-none');
  }
})


$(document).on('change keyup keydown', '.quantity', function () {
  var item_id = get_item_id($(this))[0];
  var key = get_item_id($(this))[1];
  if (event.keyCode == 8) {
    var current_value = 0;
  }else{
    var current_value = $(this).val();
  }
  if ((parseInt(current_value) || 0 ) >=1 ) {
    $('.add_item_button_' + item_id).prop('disabled', false)
  } else {
    $('.add_item_button_' + item_id).prop('disabled', true)
  }
  // if ((parseInt(current_value) || 0 ) >=1 ) {
  //   $('.quantity-box-' + item_id).text(current_value);
  // }else{
  //   $('.quantity-box-' + item_id).text(0);
  // }
  $('.item-pop-quantity-box-' + item_id).text(current_value);
  $('.item_' + item_id + '_increase_decrease').val(true);
  update_total(item_id, key);
  check_all_conditions_are_satisfied(item_id)
});
